var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnedrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 192,
    height: 124,
    viewBox: "0 0 192 124",
    id: "onedrive",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "103.648%",
    x2: "3.848%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D58BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0A3070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: "0%",
    x2: "105.047%",
    y1: "58.792%",
    y2: "77.978%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#007FC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00E6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: "4.973%",
    x2: "101.385%",
    y1: "6.558%",
    y2: "97.733%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0094F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00C8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: "6.798%",
    x2: "86.84%",
    y1: "16.006%",
    y2: "57.988%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#004FA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#006DD9"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "g",
    width: 512,
    height: 512,
    x: -476,
    y: -512,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "k",
    width: 512,
    height: 512,
    x: -503,
    y: -454.322,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "o",
    width: 512,
    height: 512,
    x: -399,
    y: -468,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "r",
    width: 512,
    height: 512,
    x: -512,
    y: -486,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "h",
    width: "101.6%",
    height: "101.6%",
    x: "-.8%",
    y: "-.8%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    in: "SourceAlpha",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetInner3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner3",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner3",
    result: "shadowMatrixInner3",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner3"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "l",
    width: "100.6%",
    height: "101.5%",
    x: "-.3%",
    y: "-.8%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.19 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "s",
    width: "101.8%",
    height: "102.6%",
    x: "-.9%",
    y: "-1.3%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "shadowBlurInner2",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    in: "shadowBlurInner2",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "j",
    d: "M186.965698,102.162306 C180.963575,112.17891 169.66041,121.480173 157.55483,123.02942 C149.484444,124.062251 112.817777,124.052445 47.5548302,123 C31.7600417,123 17.7470794,114.73937 8.99970484,102.944518 L113,57.6779175 L186.965698,102.162306 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "n",
    d: "M113,57.6535664 L136.845694,47.4867975 C141.764556,45.2474496 147.230327,44 152.987456,44 C174.526561,44 191.987456,61.4608948 191.987456,83 C191.987456,89.9646418 190.161843,96.5028888 186.963052,102.162306 L113,57.6535664 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "q",
    d: "M8.99970484,102.948181 C3.33797991,95.0649963 1.91846539e-13,84.4482555 1.91846539e-13,74 C1.91846539e-13,47.490332 21.490332,26 48,26 C58.4487588,26 68.1177466,29.3385967 75.9984048,35.0072315 L76,35 L113,57.6779175 L8.99970484,102.948181 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "f",
    cx: 97,
    cy: 61,
    r: 61
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    fill: "url(#g)",
    fillOpacity: 0.012
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    fill: "#000",
    filter: "url(#h)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j",
    fill: "url(#k)",
    fillOpacity: 0.012
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j",
    fill: "#000",
    filter: "url(#l)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n",
    fill: "url(#m)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n",
    fill: "url(#o)",
    fillOpacity: 0.012
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q",
    fill: "url(#p)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q",
    fill: "url(#r)",
    fillOpacity: 0.012
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q",
    fill: "#000",
    filter: "url(#s)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnedrive);
export default __webpack_public_path__ + "static/media/onedrive.0f47c2cead74ed50c420842499b691e5.svg";
export { ForwardRef as ReactComponent };